<div class="grid-header-content" data-qa="{{field}}">
    {{#if isSortable}}
        <a href="#" class="txt sortable {{#if isDraggable}}draggable{{/if}} {{#if isLastColumn}}column-management-offset{{/if}}">
            <span class="column-header-icon sortable">
				{{icon name="boxes-columns" text="Drag column" className="new-drag-icon" }}
				{{icon name="arrow-up" text="Sort column asc" className="new-asc-icon" }}
				{{icon name="arrow-down" text="Sort column desc" className="new-desc-icon" }}
			</span>
			<span class="title-value">{{label}}</span>
		</a>
    {{else}}
        <span class="txt {{#if isDraggable}}draggable{{/if}} {{#if isLastColumn}}column-management-offset{{/if}}" aria-label="{{ label }}" tabindex="0">
			<span class="column-header-icon sortable {{#unless isDraggable}}hidden{{/unless}}"></span>
			<span class="title-value">{{label}}</span>
		</span>
    {{/if}}

    {{#if isResizable}}
        <div role="presentation" class="grid-column-resize-marker ui-resizable-handle ui-resizable-e">&nbsp;</div>
    {{/if}}
</div>